/**
 * Append UTM tracking parameters to a URL.
 * - Only mutates absolute http(s) URLs — leaves relative paths, mailtos, tel:, hash links untouched.
 * - Never overwrites UTM keys the admin already set on the base URL.
 * - Preserves any other existing query string.
 *
 * Defaults: utm_source=wnc_site, utm_campaign=register.
 * Callers pass utm_medium (required for meaningful attribution) and optionally utm_content.
 *
 * Example:
 *   appendUtm('https://eventbrite.com/e/wnc-2027', { utm_medium: 'nav' })
 *   → 'https://eventbrite.com/e/wnc-2027?utm_source=wnc_site&utm_campaign=register&utm_medium=nav'
 */
export function appendUtm(url, params = {}) {
  if (!url || typeof url !== 'string') return url;
  if (!/^https?:\/\//i.test(url)) return url;
  try {
    const u = new URL(url);
    const merged = {
      utm_source: 'wnc_site',
      utm_campaign: 'register',
      ...params,
    };
    Object.entries(merged).forEach(([k, v]) => {
      if (v == null || v === '') return;
      if (!u.searchParams.has(k)) u.searchParams.set(k, v);
    });
    return u.toString();
  } catch {
    return url;
  }
}
